/**
 * ユーザー登録サービス
 *
 * ログイン時に以下を行う:
 * 1. dot99 の users コレクションをチェック
 * 2. 存在しなければ users ドキュメントを作成
 * 3. ウォレット未作成なら createWalletTasks を作成してウォレット生成をトリガー
 */

import { doc, getDoc, serverTimestamp, setDoc } from 'firebase/firestore';

import { db, existingDb } from './firebase';

/**
 * ユーザー登録とウォレット作成を確認
 * - 新規ユーザー: ユーザー作成 + ウォレットタスク作成
 * - 既存ユーザー（ウォレットなし）: ウォレットタスク作成
 * - 既存ユーザー（ウォレットあり）: 何もしない
 * @param uid Firebase Auth UID
 */
export async function ensureUserRegistered(uid: string): Promise<void> {
  // 1. dot99 の users コレクションをチェック
  const userRef = doc(existingDb, 'users', uid);
  const userSnap = await getDoc(userRef);

  if (userSnap.exists()) {
    // 既存ユーザー → ウォレットがあるか確認
    const userData = userSnap.data();
    if (userData.walletAddress) {
      // ウォレットあり → 何もしない
      return;
    }
    // ウォレットなし → ウォレットタスク作成へ進む
  } else {
    // 2. 新規ユーザー → users ドキュメントを作成
    await setDoc(userRef, {
      publicKey: null,
      walletAddress: null,
      encryptedWallet: null,
      salt: null,
      createdAt: serverTimestamp(),
      updatedAt: serverTimestamp(),
      deletedAt: null,
    });
  }

  // 3. ウォレット生成タスクを作成
  const taskRef = doc(db, 'createWalletTasks', `${uid}_${Date.now()}`);
  await setDoc(taskRef, {
    uid,
    status: 'ready',
    startedAt: null,
    completedAt: null,
    failedAt: null,
    errorMessage: null,
    createdAt: serverTimestamp(),
    updatedAt: serverTimestamp(),
    deletedAt: null,
  });
}
